import { createSelector } from 'reselect';
import { MapiState } from 'uf/mapi/state';
import { UFState } from 'uf/state';

function getMapiState(state: UFState): MapiState {
  return state.mapi;
}

export const getSearchInfo = createSelector(getMapiState, mapi => mapi);
